import { guardClient } from '../_axios'

/**
 * カラム新規作成
 * [post]/tasks/columns
 */
export type InsertColumnRequest = {
  title: string
}

export const insertColumn = async (request: InsertColumnRequest) => {
  const path = '/tasks/columns'
  const response = await guardClient.post(path, request)
  return response.data
}
